import { render, staticRenderFns } from "./givenList.vue?vue&type=template&id=a7c11892&scoped=true&"
import script from "./givenList.vue?vue&type=script&lang=js&"
export * from "./givenList.vue?vue&type=script&lang=js&"
import style0 from "./givenList.vue?vue&type=style&index=0&id=a7c11892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c11892",
  null
  
)

export default component.exports